import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { PDPPriceSection } from '../../../Components/PDPPriceSection/PDPPriceSection.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-monetate';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/fun-products';
import 'classnames';
import '@grandvisionhq/reviews';
import '@grandvisionhq/common';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/frk-routing';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const SolutionsPriceSection = ({ className  })=>{
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const { purchaseType  } = state.configurations;
    const productPrices = activeVariant.purchaseTypePrices && activeVariant.purchaseTypePrices[purchaseType];
    if (!productPrices || !CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    const { originalPrice , discountedPrice , discountInfo , unitPrice  } = productPrices;
    return /*#__PURE__*/ React.createElement(PDPPriceSection, {
        className: className,
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        discountDescription: discountInfo === null || discountInfo === void 0 ? void 0 : discountInfo.discountDescription,
        discountBadge: discountInfo === null || discountInfo === void 0 ? void 0 : discountInfo.discountBadge,
        unitPrice: unitPrice,
        bestPrice: activeVariant.bestPrice
    });
};

export { SolutionsPriceSection };
//# sourceMappingURL=SolutionsPriceSection.js.map
